import { MaybeRef, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { whenAuthenticated } from '@/utils/query-utils'

export const useGeneratorReportGetQuery = (reportNumber: MaybeRef<string>, componentSid: MaybeRef<string>) => {
    return useQuery({
        queryKey: ['reports', 'details', reportNumber, componentSid],
        queryFn: async ({ signal }) => {
            const {
                data: { result },
            } = await hcaClientFactory.reportsApi.getGeneratorReport(toValue(reportNumber), toValue(componentSid), { signal })
            return result
        },
        enabled: whenAuthenticated,
    })
}
